import type { Command } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommandTransaction } from '@wix/cli-panorama';
import { reportCommandStartEvent } from '@wix/cli-telemetry';

export async function runCommand(
  command: Command<unknown[]>,
  services: CommandServices,
  cliVersion: string,
  commandFn: () => Promise<void>
) {
  const commandStatus = reportCommandStartEvent({
    biLogger: services.biLogger,
    cliVersion,
    command,
    flow: null,
  });
  const transaction = createCommandTransaction(services.panorama, command);

  try {
    transaction.start();
    await commandFn();
    transaction.finish();
    commandStatus.succeed();
  } catch (error) {
    commandStatus.failed(error);
    throw error;
  }
}
